import React from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const CommonBreadCrumb = ({ paths, tabType }) => {
  const navigate = useNavigate();
  const onCommonBredcrumb = (idx, totalIdx, path) => {
    if(idx === 0){
      navigate(path?.url)
    }else{
      window.history.go(idx-totalIdx)
    }
  }
  return (
    <div className='paddingTopBottom10'>
      <Breadcrumbs
        separator={<NavigateNextIcon className='colorGrey' fontSize="small" />}
        aria-label="breadcrumb"
      >
        {paths.map((path, index) =>
          index === paths.length - 1 ? (
            <Typography key={path.name} className={`cursorDefault ${path.className}`}>
              {path.name}
            </Typography>
          ) : (
            <div key={path.name} className='colorGrey fontSemi textDecorationNone cursor' onClick={() => {onCommonBredcrumb(index, paths.length - 1, path)}}>
              {path.name}
            </div>
          )
        )}
      </Breadcrumbs>
    </div>
  );
};

export default CommonBreadCrumb;
